import packageInfo  from '../package.json';

console.log('web app version: ' + packageInfo.version);
window.document.getElementById('web-version').innerText = packageInfo.version;
